// this is an autogenerated file from DesignSystem/TasksViewForm/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksViewForm($id: uuid!) {
  tasks_tasks_by_pk(id: $id) {
    id
    board_id
    created_at
    created_by_user {
      id
      vaxiom_person {
        id
        _id
        first_name
        last_name
      }
    }
    board {
      id
      name
    }
    stage {
      id
      name
      done
    }
    title
    description
    order
    due_date
    priority
    comments(order_by: { created_at: desc }) {
      id
      value
      created_at
      created_by_user {
        id
        vaxiom_person {
          id
          _id
          first_name
          last_name
        }
      }
    }
    task_tags {
      id
      tag {
        id
        name
      }
    }
    assignees {
      id
      user_id
      user {
        id
        display_name
        vaxiom_person {
          id
          _id
          first_name
          last_name
        }
      }
    }
    patients {
      id
      _id
      person {
        id
        _id
        greeting
        first_name
        last_name
      }
    }
    resources(order_by: { created_at: desc }, limit: 1) {
      id
      type
      resource_id
      document_template {
        id
        name
      }
      metadata
      document_id
      document_tree_node {
        id
        name
      }
    }
  }
}

`